import {useState} from 'react';
import {useQuery} from '@tanstack/react-query';
import {Download,FileText,LoaderCircle} from 'lucide-react';
import type {AttachmentView} from '@api/service-desk/attachments';
import {downloadTicketAttachment,getTicketAttachment} from '../lib/api';
import {fileSize} from './file-input';

const labels={allocated:'Uploading',quarantined:'Checking file',ready:'Ready to download',blocked:'File unavailable',unavailable:'File could not be checked',expired:'File expired'};
export function TicketFile({file,mspId,ticketId}:{file:AttachmentView;mspId:string;ticketId:string}){
  const [downloading,setDownloading]=useState(false),[error,setError]=useState('');
  const query=useQuery({queryKey:['scope',mspId,'ticket-file',ticketId,file.id],initialData:file,
    queryFn:({signal})=>getTicketAttachment(mspId,ticketId,file.id,signal),
    refetchInterval:q=>document.visibilityState==='visible'&&['allocated','quarantined'].includes(q.state.data?.state??file.state)?5000:false});
  const current=query.data??file;
  async function download(){
    setDownloading(true);setError('');
    try{
      await downloadTicketAttachment(mspId,ticketId,file.id,current.filename);
    }catch{setError('This file could not be downloaded. Check its status and retry.');void query.refetch();}
    finally{setDownloading(false);}
  }
  return <div className="mt-3 rounded-lg border border-line bg-canvas/70 px-3 py-2.5 text-xs">
    <div className="flex items-center gap-3"><FileText aria-hidden="true" className="size-4 shrink-0 text-ink-3"/><div className="min-w-0 flex-1"><p className="break-all font-medium text-ink">{current.filename}</p><p className="mt-0.5 text-ink-3">{fileSize(current.size)} · {query.isError?'Status unavailable':labels[current.state]}</p></div>
      {current.state==='ready'&&<button type="button" disabled={downloading} onClick={()=>{void download();}} aria-label={'Download '+current.filename} className="rounded-md p-2 text-ink-2 hover:bg-sunken disabled:opacity-50">{downloading?<LoaderCircle aria-hidden="true" className="size-4 animate-spin"/>:<Download aria-hidden="true" className="size-4"/>}</button>}
    </div>{error&&<p role="alert" className="mt-2 text-attention">{error}</p>}
  </div>;
}
